// removed by extract-text-webpack-plugin
module.exports = {"AdminDropMenu":"AdminDropMenu__-loca-__3FFrA","Image":"AdminDropMenu__-loca-__1t7RB","TextGroup":"AdminDropMenu__-loca-__1HekR","Edition":"AdminDropMenu__-loca-__1FI8-","Name":"AdminDropMenu__-loca-__3NxqU","Variant":"AdminDropMenu__-loca-__3tolv","NumberAvailable":"AdminDropMenu__-loca-__36cud","Registrations":"AdminDropMenu__-loca-__4LajN","TextGrid":"AdminDropMenu__-loca-__mees1","Cost":"AdminDropMenu__-loca-__3lOnD","Result":"AdminDropMenu__-loca-__29f4N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/AdminDropMenu/AdminDropMenu.css
// module id = 229
// module chunks = 0